import { useMemo, type ReactNode } from "react";

import { LocaleContext, type LocaleValue } from "./LocaleContext";
import { resolveLocale } from "./locale";
import { messages, type Locale } from "./messages";

function translator(locale: Locale) {
  return (key: keyof typeof messages) => messages[key][locale];
}

export function LocaleProvider({
  languageTag,
  children,
}: {
  languageTag: string | undefined;
  children: ReactNode;
}) {
  const value = useMemo<LocaleValue>(() => {
    const locale = resolveLocale(languageTag);
    return { locale, t: translator(locale) };
  }, [languageTag]);
  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
}
